import { useAuth } from '@/hooks/use-auth';
import { AppHeader } from '@/components/app-header';
import type { BrandIdentityDto } from '@/types/brand';

interface AppLayoutProps {
    children: React.ReactNode;
    hasOrdersCapability: boolean;
    /** The Results tab: brand owner sessions of a brand that takes orders (D18). */
    showResults: boolean;
    /** The tenant's WhatsApp channel is on: chats, templates, playground and the kill switch. */
    showWhatsappChrome: boolean;
    /** The Chats tab: the WhatsApp chrome, unless the brand hides its chats from this sucursal. */
    showInbox: boolean;
    /** A WhatsApp line is actually connected — the per-line surfaces need one. */
    hasWhatsappLine: boolean;
    brandName?: string;
    brandIdentity?: BrandIdentityDto;
    phone?: string;
    aiAgentEnabled: boolean;
    aiAgentPaused: boolean;
    hasBrand: boolean;
    onToggleAiAgent: (paused: boolean) => Promise<void>;
    pendingOrdersCount?: number;
    handoffCount?: number;
}

export function AppLayout({
    children,
    hasOrdersCapability,
    showResults,
    showWhatsappChrome,
    showInbox,
    hasWhatsappLine,
    brandName,
    brandIdentity,
    phone,
    aiAgentEnabled,
    aiAgentPaused,
    hasBrand,
    onToggleAiAgent,
    pendingOrdersCount,
    handoffCount,
}: AppLayoutProps) {
    const { session, logout } = useAuth();

    return (
        <div className="h-dvh flex flex-col">
            <AppHeader
                session={session}
                onLogout={logout}
                hasOrdersCapability={hasOrdersCapability}
                showResults={showResults}
                showWhatsappChrome={showWhatsappChrome}
                showInbox={showInbox}
                hasWhatsappLine={hasWhatsappLine}
                brandName={brandName}
                brandIdentity={brandIdentity}
                phone={phone}
                aiAgentEnabled={aiAgentEnabled}
                aiAgentPaused={aiAgentPaused}
                hasBrand={hasBrand}
                onToggleAiAgent={onToggleAiAgent}
                pendingOrdersCount={pendingOrdersCount}
                handoffCount={handoffCount}
            />
            <div className="flex-1 flex overflow-hidden relative">{children}</div>
        </div>
    );
}
